import { render, staticRenderFns } from "./cob-vue-suggestion.vue?vue&type=template&id=f6c6b048&"
import script from "./cob-vue-suggestion.vue?vue&type=script&lang=js&"
export * from "./cob-vue-suggestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hugomarcelino/projects/cob/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6c6b048')) {
      api.createRecord('f6c6b048', component.options)
    } else {
      api.reload('f6c6b048', component.options)
    }
    module.hot.accept("./cob-vue-suggestion.vue?vue&type=template&id=f6c6b048&", function () {
      api.rerender('f6c6b048', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/recordm/fields/cob-vue-suggestion.vue"
export default component.exports